import React, { useEffect, useState } from 'react'
import { Container, Row, Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getCardsManagers, approveCards } from '../../../actions/cardsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import moment from 'moment-timezone'
import { useNavigate } from 'react-router-dom'
import { Fragment } from 'react'
import Swal from 'sweetalert2'

export default function Cards() { 
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {cards} = useSelector((state) => state.cards)

    const [extratimes, setExtratimes] = useState({})

    useEffect(()=>{
        dispatch(getCardsManagers())
    }, [dispatch])

    useEffect(()=>{
        if(cards){
            let arrayExtratimes = {}
            cards.forEach(card => {
                let extratimecard = card.extratime
                let cardtime = 'No hay trabajo especial'
                if(extratimecard === 0){
                    let miliseconds = new Date(card.out) - new Date(card.in)
                    let diferencia = miliseconds - 28800000

                    if(diferencia > 1800000){
                        let minutes = Math.floor((diferencia / (1000 * 60)) % 60)
                        let hours = Math.floor((diferencia / (1000 * 60 * 60))) -8

                        cardtime = hours+' '+t('alert.hours')+' '+minutes+' '+t('alert.minutes')
                    }
                }else{
                    let minutes = Math.floor((extratimecard / (1000 * 60)) % 60)
                    let hours = Math.floor((extratimecard / (1000 * 60 * 60)))

                    cardtime = hours+' '+t('alert.hours')+' '+minutes+' '+t('alert.minutes')
                }

                arrayExtratimes[card._id] = cardtime
            })
            setExtratimes(arrayExtratimes)
        }
    }, [cards])

    const approveCard = (extratimecard, idCard, cardin, cardout) => {
        // if(extratimecard === 0){
        //     let miliseconds = new Date(cardout) - new Date(cardin)
        //     let diferencia = miliseconds - 28800000

        //     if(diferencia > 1800000){
        //         let minutes = Math.floor((diferencia / (1000 * 60)) % 60)
        //         let hours = Math.floor((diferencia / (1000 * 60 * 60))) -8

        //         minutes = (minutes < 10) ? "0" + minutes : minutes

        //         Swal.fire({
        //             title: t('alert.extratime'),
        //             text: t('alert.extratime1')+' '+hours+' '+t('alert.hours')+' '+minutes+' '+t('alert.minutesmore'),
        //             input: 'select',
        //             inputOptions: {
        //             extra: 'Trabajo especial',
        //             laborables: 'Horas laborables',
        //             nocount: 'No contables'
        //             },
        //             showDenyButton: true,
        //             confirmButtonText: t('alert.confirm'),
        //             denyButtonText: t('alert.goback'),
        //             inputValidator: (value) => {
        //             return new Promise(() => {
        //                 dispatch(approveCards(idCard, diferencia, value))
        //                 dispatch(getCardsManagers())
        //                 Swal.fire({
        //                     showConfirmButton: true,
        //                     confirmButtonText: t('card.letsok'),
        //                     icon: 'success',
        //                     text: t('card.approved')
        //                 })
        //             })
        //             }
        //         })
        //     }else{
        //         dispatch(approveCards(idCard, diferencia, null))
        //         dispatch(getCardsManagers())
        //         Swal.fire({
        //             showConfirmButton: true,
        //             confirmButtonText: t('card.letsok'),
        //             icon: 'success',
        //             text: t('card.approved')
        //         })
        //     }
        // }else{
            // let minutes = Math.floor((extratimecard / (1000 * 60)) % 60)
            // let hours = Math.floor((extratimecard / (1000 * 60 * 60)))

            // minutes = (minutes < 10) ? "0" + minutes : minutes

            Swal.fire({
                title: t('alert.extratime'),
                text: t('alert.extratimechecked2'),
                input: 'select',
                inputOptions: {
                    // extra: 'Trabajo especial',
                    // laborables: 'Horas laborables',
                    nocount: 'No',
                    badresponse: 'Si'
                },
                showDenyButton: true,
                confirmButtonText: t('alert.confirm'),
                denyButtonText: t('alert.goback'),
                inputValidator: (value1) => {
                    if(value1 = 'badresponse'){
                        Swal.fire({
                            title: t('alert.extratime'),
                            text: t('alert.sethours'),
                            input: 'number',
                            showDenyButton: true,
                            confirmButtonText: t('alert.confirm'),
                            denyButtonText: t('alert.canceled'),
                            inputValidator: (value2) => {
                                return new Promise(() => {
                                    dispatch(approveCards(idCard, (value2 * 3600000), 'extra'))
                                    dispatch(getCardsManagers())
                                    Swal.fire({
                                        showConfirmButton: true,
                                        confirmButtonText: t('card.letsok'),
                                        icon: 'success',
                                        text: t('card.approved')
                                    })
                                })
                            }
                        })
                    }else{
                        return new Promise(() => {
                            dispatch(approveCards(idCard, extratimecard, value1))
                            dispatch(getCardsManagers())
                            Swal.fire({
                                showConfirmButton: true,
                                confirmButtonText: t('card.letsok'),
                                icon: 'success',
                                text: t('card.approved')
                            })
                        })
                    }
                }
            })
        // }
    }

    const goBack = () => {
        navigate('/administrative/dashboard')
    }

    // Datatables
    const columns = [
        {
            name: t('resume.datain'),
            cell: cards =>
            <div className='row col-12'>
                    <div className='col-12 col-md-3'>
                        <br/>
                        <label>{t('users.Encargado')}</label>: {cards.user.firstname} {cards.user.lastname}<br/>
                        <label>{t('resume.fechahoraentrada')}</label>: {moment(new Date(cards.in)).format('HH:mm:ss')} {moment(new Date(cards.in)).format('DD-MM-YYYY')}<br/>
                        <label>{t('resume.fechahorasalida')}</label>:&nbsp;
                        {cards.out !== null
                            ?
                                moment(new Date(cards.out)).format('HH:mm:ss')+' '+moment(new Date(cards.out)).format('DD-MM-YYYY')
                            :
                                <>{t('resume.sinsalida')}</>
                        }
                        <br/>{t('resume.extratime')}: {extratimes[cards._id]}
                        <br/><br/><label>{t('resume.farm')}</label>: {cards.plot.farm.name}<br/>
                        <label>{t('resume.plot')}</label>: {cards.plot.name}<br/>
                        <label>{t('resume.crop')}</label>: {cards.crop.name}<br/><br/>
                        <label>{t('resume.labor')}</label>: {cards.labor.name}
                        <br/><br/>
                    </div>
                    <div className='col-12 col-md-3'>
                        {cards.machinery ?
                            <>
                                <br/>
                                <label>{t('resume.machinery')}:</label> {cards.machinery.name}<br/>{cards.machinery.plate}<br/><br/>
                                <label>{t('resume.litres')}</label><br/>
                                <label>{t('resume.litres_gasoil')}:</label> {cards.litres_gasoil ? cards.litres_gasoil : '0'}<br/>
                                <label>{t('resume.litres_engine_oil')}:</label> {cards.litres_engine_oil ? cards.litres_engine_oil : '0'}<br/>
                                <label>{t('resume.litres_hydraulic_oil')}:</label> {cards.litres_hydraulic_oil ? cards.litres_hydraulic_oil : '0'}<br/>
                                <label>{t('resume.litres_urea')}:</label> {cards.litres_urea ? cards.litres_urea : '0'}<br/>
                                {/* <label>{t('resume.litres_antifreeze')}:</label> {cards.litres_antifreeze ? cards.litres_antifreeze : '0'}<br/> */}
                                <label>{t('resume.litres_grease')}:</label> {cards.litres_grease ? cards.litres_grease : '0'}<br/>
                            </>
                        :
                            <></>
                        }
                    </div>
                    <div className='col-12 col-md-3'>
                        {cards.products.length > 0 ?
                            <>
                                <br/>
                                <span>{t('landingoperator.products')}:</span><br/>
                                {cards.products?.map((product, key) =>{
                                    return (
                                        <Fragment key={key}><span key={key}> - {product.product.name}: {product.quantity}{product.type}</span><br/></Fragment>
                                    )
                                })}
                            </>
                        :
                            <></>
                        }
                        {cards.product_extra.length > 0 ?
                            <>
                                <br/>
                                <span>{t('landingoperator.otherproducts')}:</span><br/>
                                {cards.product_extra?.map((product, key) =>{
                                    return (
                                        <Fragment key={key}><span key={key}> - {product.product}: {product.quantity}{product.type}</span><br/></Fragment>
                                    )
                                })}
                            </>
                        :
                            <></>
                        }
                    </div>
                    <div className='col-12 col-md-3 d-flex'>
                        <div className='col-6'>
                        <br/>
                            {cards.out !== null
                                ?
                                <Button variant="outline-success w-50 mx-auto" onClick={() => approveCard(cards.extratime, cards._id, cards.in, cards.out)}>
                                    <i className="fas fa-clipboard-check"></i>
                                </Button>
                                :
                                <></>
                            }
                        </div>
                        <div className='col-6'>
                        <br/>
                            <Button variant="outline-warning w-50 mx-auto" href={`/administrative/card/`+cards._id}>
                                <i className="fas fa-paste"></i>
                            </Button>
                        </div>
                    </div>
            </div>,
            selector: (cards) => cards._id,
            sortable: true,
        }
    ]

    return (
        <>
            <Container>
                <Row className="text-left custom-card-header">
                    <Row className="custom-card-buttom">
                        <Button className="btn btn-secondary mb-4 mx-auto" onClick={goBack}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                    </Row>
                    <h1>{t('manager.managecards')}</h1>
                    <Form.Label className="form-label">{t('manager.selectaction')}</Form.Label>
                    <br/><br/><br/>
                </Row>
                <Row className="text-left custom-card-body justify-content-center">
                    <Row className="text-center justify-content-center">
                        {cards 
                            ?
                                <CustomDataTable columns={columns} data={cards} />
                            :
                                <></>
                        }
                    </Row>
                </Row>
            </Container>
        </>
    )
}


  
                
